import { Component, OnInit, Input } from '@angular/core';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { CalibrationService } from 'src/app/calibration/calibration.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { BaseClass } from 'src/app/shared/classes/base';
import { UsersService } from 'src/app/users/users.service';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'app-import-employee-number',
  templateUrl: './import-employee-number.component.html',
  styleUrls: ['./import-employee-number.component.scss'],
})
export class ImportEmployeeNumber extends BaseClass implements OnInit {

  public data: string = "";
  public replace: boolean = false;
  public users: any;
  public idsNotFound = [];
  public idsNotFoundString = "";
  public limitUsersToGetReport: number = 10;

  @Input() cycleId: any;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _loadingController: LoadingController,
    private _modalController: ModalController,
    private _reportsService: ReportsService) {
    super(_toastController, _translationService);
  }

  ngOnInit() { }

  private dismiss(data?: any) {
    this._modalController.dismiss(data);
  }

  public async send(): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();



    this._reportsService.getUsersByEmployee(this.data)
      .subscribe(
        response => {
          loading.dismiss();
          var canSend = this.data && this.data !== '';


          if (!canSend) {
            loading.dismiss();
            this.notify(this._translationService.getTranslation("report.cgeRequiredToImport"), 'danger');
            return;
          }

          var idsSent = this.data.split('\n');
          var idsReturned = [];
          response.data.forEach(element => {
            idsReturned.push(element.employeeNumber.toString())
          });

          this.idsNotFound = [];
          this.idsNotFoundString = "";

          idsSent.forEach((id, index) => {
            if (!idsReturned.includes(id) && index < this.limitUsersToGetReport) {
              if (id && id !== '') {
                this.idsNotFound.push(id);
                if (this.idsNotFoundString !== "")
                  this.idsNotFoundString += ", " + id + " (" + (index + 1) + "º)";
                else
                  this.idsNotFoundString += id + " (" + (index + 1) + "º)";
              }
            }
          });

          if (this.idsNotFound.length === 0)
            this.dismiss([response.data]);

        }, error => {
          loading.dismiss();

          if(error.status === 403)
            this.notify(this._translationService.getTranslation("generic.notEnoughAccess"), "danger");
          else
            this.notifyError(error);
        });
  }

  public cancel() {
    this.dismiss();
  }
}
